type PlaceIdHashList = {
    [key: string]: string[];
};

export const PlaceSetting: PlaceIdHashList = {
    development: [
        "BndAjWjX", //サイネージ検証用トイレplace1
        "arZ01wWX", //サイネージ検証用トイレplace2
        "vrE27bDn", //サイネージ検証用トイレplace3
        "pnyZW0NX", //サイネージ検証用トイレplace4
        "jX51QzAX", //サイネージ検証用トイレplace5
        "4r6k3Don", //サイネージ検証用トイレplace6
        "NXgbWBln", //サイネージ検証用トイレplace7
        "5r012GAn", //サイネージ検証用トイレplace8
        "qr7BLMW9", //サイネージ検証用トイレplace9
        "grjqYla9", //サイネージ検証用トイレplace10
        "5XkeWw4r", //サイネージ検証用トイレplace11
        "oXRdobqr", //サイネージ検証用トイレplace12
        "ZnxwpYor", //サイネージ検証用トイレplace13
        "krbJ0Ngr", //サイネージ検証用トイレplace14
    ],
    staging: [
        "59e6jwrv", //あなぶき_2F_7個室
        "pnyRyNXP", //あなぶき_2F_7個室_Mens
        "L943QmX4", //あなぶき_2F_17個室
        "jX5LBAnN", //あなぶき_2F_17個室_Mens
        "vX2o0K9Q", //あなぶき_2F_22個室
        "4r6z7orJ", //あなぶき_2F_22個室_Mens
        "Q9VK5qr0", //あなぶき_1F_15個室
        "NXgMelrA", //あなぶき_1F_15個室_Mens
        "yXPANg9d", //あなぶき_1F_14個室
        "5r0PBArO", //あなぶき_1F_14個室_Mens
        "k9oR3lXg", //あなぶき_1F_13個室
        "grjMVa9q", //あなぶき_1F_13個室_Mens
        "pXGAV1rM", //あなぶき_1F_11個室
        "qr7Y0WXV", //あなぶき_1F_11個室_Mens
    ],
    production: [
        "59e6jwrv", //あなぶき_2F_7個室
        "pnyRyNXP", //あなぶき_2F_7個室_Mens
        "L943QmX4", //あなぶき_2F_17個室
        "jX5LBAnN", //あなぶき_2F_17個室_Mens
        "vX2o0K9Q", //あなぶき_2F_22個室
        "4r6z7orJ", //あなぶき_2F_22個室_Mens
        "Q9VK5qr0", //あなぶき_1F_15個室
        "NXgMelrA", //あなぶき_1F_15個室_Mens
        "yXPANg9d", //あなぶき_1F_14個室
        "5r0PBArO", //あなぶき_1F_14個室_Mens
        "k9oR3lXg", //あなぶき_1F_13個室
        "grjMVa9q", //あなぶき_1F_13個室_Mens
        "pXGAV1rM", //あなぶき_1F_11個室
        "qr7Y0WXV", //あなぶき_1F_11個室_Mens
    ],
};
